import { colors } from '@ui/colors'
import { ActivityIndicator, StyleProp, ViewProps } from 'react-native'
import Animated from 'react-native-reanimated'
import cn from '@ui/utils/cn'

interface Props {
  color?: string
  style?: StyleProp<ViewProps>
  className?: string
}

export const LoadingFooter = ({
  color = colors.text,
  style = {},
  className,
}: Props) => {
  return (
    <Animated.View
      className={cn(
        'w-full items-center justify-center px-8 pb-16 pt-24',
        className
      )}
      style={style}
    >
      <ActivityIndicator color={color} size="large" />
    </Animated.View>
  )
}
